module.exports = __webpack_public_path__ + "assets/icon_friend_add_feedback.svg?v=cd8b66fbb05c4fd735ebd7bd203d6c8e";